import Seo, { SITE_URL } from "@/components/feature/Seo";
import Hero from "./components/Hero";
import Featured from "./components/Featured";
import GenreNav from "./components/GenreNav";
import Ranking from "./components/Ranking";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Cta from "./components/Cta";
import { faqs } from "@/mocks/comics";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "天天漫画网",
      url: SITE_URL,
      description: "长期连载漫画库，稳定更新不断更，追更神器在手。",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "天天漫画网",
      url: SITE_URL,
      description: "天天漫画网长期连载漫画库，长篇神作、持续连载精品一网打尽。",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.question,
        acceptedAnswer: { "@type": "Answer", text: f.answer },
      })),
    },
  ];

  return (
    <>
      <Seo
        title="天天漫画网 - 长期连载漫画库 · 稳定更新追更神器"
        description="天天漫画网长期连载漫画库，稳定更新不断更！长篇神作、持续连载精品一网打尽，告别追更焦虑，点开即享稳定连载体验，追更神器在手。"
        keywords="天天漫画网,长期连载,长篇漫画,持续更新,追更神器"
        canonical={SITE_URL}
        jsonLd={jsonLd}
      />
      <Hero />
      <Featured />
      <GenreNav />
      <Ranking />
      <Features />
      <Testimonials />
      <Faq />
      <Cta />
    </>
  );
}